import ConnectWrapper from './ConnectWrapper';

export default ConnectWrapper;
